import {
  Box,
  HStack,
  Text,
  VStack,
  IconButton,
  ButtonGroup,
  Grid,
} from "@chakra-ui/react";
import "../index.css";
import { Image } from "../reusables";
// import Lottie from "lottie-react";
// import waveformAnim from "../../assets/lottie/waveform.json";
import { AnimatePresence, motion } from "framer-motion";
import { memo, useState } from "react";
import { FaPlay } from "react-icons/fa";
import { CgChevronDown } from "react-icons/cg";
import dayjs from "../../helpers/dayJs";
import useColorAccent from "../../hooks/useColorAccent";
import { Link, useNavigate } from "react-router";
import { FiArrowRight, FiPlay, FiTrash } from "react-icons/fi";
import formatUsername from "../../helpers/formatUsername";
import { useHlsAudioActions } from "../../wrappers/hlsAudio";
// import { useHover } from "@uidotdev/usehooks";

/**
 * @typedef {Object} MusicProps
 * @property {string} [title]
 * @property {object} [user]
 * @property {string} [id]
 * @property {object[]} thumbnails
 * @property {{fileName?: string, thumbnails?: object[]}} track
 * @prop {number} [durationSec]
 * @property {import("@chakra-ui/react").StackProps} [container]
 * @property {import("@chakra-ui/react").StackProps} [overlay]
 */

const MusicCard = {};
MusicCard.formatDuration = (durationSec = 0) => {
  return dayjs.utc(durationSec * 1000).format("m:ss");
};

/**
 * @param {MusicProps} props
 */
MusicCard.ListItemLarge = memo(function ListItemLargeCard(props) {
  // const { actions } = useHlsAudio();
  const { playTrack } = useHlsAudioActions();
  const navigate = useNavigate();
  const thumbnailFileName =
    props.track?.thumbnails?.[props.track?.thumbnails?.length - 1]?.fileName;

  const MotionText = motion(Text);
  const [imageHovered, setImageHovered] = useState(false);

  function performPlay() {
    playTrack(props.profileId, props.postId, props);
  }

  function navigateToPost() {
    navigate(`/user/${props.username}/post/${props.postId}`);
  }

  return (
    <Grid
      gridTemplateColumns={"90px 1fr"}
      gridTemplateRows={"repeat(2, 1fr)"}
      // minH="75px"
      h="75px"
      w="full"
      borderRadius={"md"}
      spacing={"2"}
      align={"flex-start"}
      pos={"relative"}
      columnGap={"5"}
      cursor={"pointer"}
      onClick={navigateToPost}
      {...props.container}
    >
      <Box
        h="full"
        w="full"
        borderRadius="md"
        pos="relative"
        overflow={"visible"}
        cursor={"pointer"}
        role="group"
        transition={"all 150ms"}
        transformOrigin={"top"}
        _hover={{
          transform: "scale(1.04)",
        }}
        gridArea={"1 / 1 / 3 / 2"}
      >
        <Image
          h="full"
          w="full"
          transition={"all 150ms"}
          borderRadius="md"
          src={props.thumbnailUrl}
          objectFit="cover"
          transform={"scale(0.99)"}
          firebaseStoragePath={
            thumbnailFileName
              ? `photos/${props.user?.id}/${props.id}/thumbnails/${thumbnailFileName}`
              : null
          }
          //   animation={"heartbeat 1s infinite"}
        />
      </Box>
      <VStack
        w="full"
        spacing={"0"}
        align={"flex-start"}
        justify={"center"}
        gridArea={"1 / 2 / 2 / 3"}
      >
        <Text
          noOfLines={"2"}
          fontSize={"13px"}
          fontWeight={"medium"}
          _hover={{ textDecor: "underline" }}
          cursor={"pointer"}
        >
          {props.title}
        </Text>
        <Text
          noOfLines={"1"}
          fontSize={"12px"}
          fontWeight={"normal"}
          color="gray.400"
          _hover={{ textDecor: "underline" }}
          cursor={"pointer"}
        >
          {props.username}
        </Text>
        {/* <HStack></HStack> */}
      </VStack>
      <Text
        gridArea={"2 / 2 / 3 / 3"}
        fontSize={"xs"}
        color="gray.400"
        alignSelf={"center"}
      >
        {/* {MusicCard.formatDuration(props.durationSec)} */}
      </Text>
    </Grid>
  );
});

/**
 * @param {MusicProps} props
 */
MusicCard.ListItem = function ListItem(props) {
  const [isContainerHovered, setIsContainerHovered] = useState(false);
  // const { actions } = useHlsAudio();
  const { playTrack } = useHlsAudioActions();
  const thumbnailFileName =
    props.track?.thumbnails?.[props.track?.thumbnails?.length - 1]?.fileName;

  const { attachImage, accentColor } = useColorAccent();

  const MotionText = motion(Text);
  const [isNameHovered, setIsNameHovered] = useState(false);

  const MotionBox = motion(Box);

  return (
    <Grid
      gridTemplateColumns={"90px 1fr auto"}
      // minH="75px"
      w="full"
      borderRadius={"md"}
      spacing={"2"}
      align={"flex-start"}
      pos={"relative"}
      columnGap={"5"}
      px="2"
      py="1.5"
      alignItems={"center"}
      _hover={{
        bg: "#2e2e3030",
      }}
      cursor={"pointer"}
      onMouseEnter={() => setIsContainerHovered(true)}
      onMouseLeave={() => setIsContainerHovered(false)}
      role="group"
      onClick={() => playTrack(props)}
      {...props.container}
    >
      <Box
        h="90px"
        transition={"all 200ms"}
        // boxShadow={`0px 0px 10px 2px ${accentColor}60`}
        overflow={"hidden"}
        borderRadius={"md"}
        _hover={{
          transform: "scale(1.05)",
          boxShadow: `none`,
        }}
      >
        <Image
          firebaseStoragePath={
            thumbnailFileName
              ? `photos/${props.user?.id}/${props.id}/thumbnails/${thumbnailFileName}`
              : null
          }
          h="90px"
          w="full"
          onLoad={attachImage}
        />
      </Box>
      <Grid w="full" h="full" gridTemplateRows={"1fr auto"}>
        <VStack
          w="full"
          spacing={"0"}
          align={"flex-start"}
          justify={"flex-start"}
        >
          <Text
            noOfLines={"1"}
            fontSize={{ base: "sm", md: "sm", lg: "xl" }}
            fontWeight={"bold"}
            _hover={{ textDecor: "underline" }}
            cursor={"pointer"}
            onMouseEnter={() => setIsNameHovered(true)}
            onMouseLeave={() => setIsNameHovered(false)}
            as={Link}
            to={`/user/${props.user?.username}/post/${props.id}`}
            onClick={(e) => e.stopPropagation()}
          >
            {props.title}
          </Text>

          <Text color={"gray.400"} fontSize={"sm"}>
            {props.user?.fullName}
          </Text>
        </VStack>
        <AnimatePresence mode="wait">
          {!isContainerHovered ? (
            <MotionBox
              key="duration"
              initial={{ opacity: 0.9, translateY: -1 }}
              animate={{ opacity: 1, translateY: 0 }}
              exit={{ opacity: 0, translateY: -10 }}
              transition={{ ease: "linear", duration: 0.03 }}
            >
              <Text fontSize={"xs"} color="gray.400">
                {MusicCard.formatDuration(props.duration)}
              </Text>
            </MotionBox>
          ) : (
            <MotionBox
              key="access_buttons"
              initial={{ opacity: 0, translateY: 10 }}
              animate={{ opacity: 1, translateY: 0 }}
              exit={{ opacity: 0, translateY: 10 }}
              transition={{ ease: "linear", duration: 0.07 }}
            >
              {!isNameHovered ? (
                <MotionBox
                  key="btn_play"
                  initial={{ opacity: 0, translateY: -10 }}
                  animate={{ opacity: 1, translateY: 0 }}
                  exit={{ opacity: 0, translateY: -10 }}
                  transition={{ ease: "linear", duration: 0.07 }}
                >
                  <HStack color={"gray.500"}>
                    <FiPlay size={13} />
                    <Text fontSize={"xs"}>Click to play</Text>
                  </HStack>
                </MotionBox>
              ) : (
                <MotionBox
                  key="btn_goToPost"
                  initial={{ opacity: 0, translateY: 10 }}
                  animate={{ opacity: 1, translateY: 0 }}
                  exit={{ opacity: 0, translateY: 10 }}
                  transition={{ ease: "linear", duration: 0.07 }}
                >
                  <HStack color={"gray.500"}>
                    <FiArrowRight size={13} />
                    <Text fontSize={"xs"}>Go To Post</Text>
                  </HStack>
                </MotionBox>
              )}
            </MotionBox>
          )}
        </AnimatePresence>
      </Grid>
      <IconButton
        onClick={(e) => {
          e.stopPropagation();
          props.onRemove && props.onRemove();
        }}
        size="sm"
        icon={<FiTrash />}
        variant={"nav"}
        opacity={0}
        _groupHover={{
          opacity: 1,
        }}
      />
    </Grid>
  );
};

/**
 * @param {MusicProps} props
 */
MusicCard.ListItemNarrow = function ListItemNarrow(props) {
  const [isContainerHovered, setIsContainerHovered] = useState(false);
  // const { actions } = useHlsAudio();
  const { playTrack } = useHlsAudioActions();
  const thumbnailFileName =
    props.track?.thumbnails?.[props.track?.thumbnails?.length - 1]?.fileName;

  const { attachImage, accentColor } = useColorAccent();

  const MotionText = motion(Text);
  const [isNameHovered, setIsNameHovered] = useState(false);

  const MotionBox = motion(Box);

  return (
    <Grid
      gridTemplateColumns={"90px 1fr auto"}
      // minH="75px"
      w="full"
      borderRadius={"md"}
      spacing={"2"}
      align={"flex-start"}
      pos={"relative"}
      columnGap={"5"}
      px="2"
      py="1.5"
      alignItems={"center"}
      _hover={{
        bg: "#2e2e3030",
      }}
      cursor={"pointer"}
      onMouseEnter={() => setIsContainerHovered(true)}
      onMouseLeave={() => setIsContainerHovered(false)}
      role="group"
      onClick={() => playTrack(props)}
      {...props.container}
    >
      <Box
        h="90px"
        transition={"all 200ms"}
        // boxShadow={`0px 0px 10px 2px ${accentColor}60`}
        overflow={"hidden"}
        borderRadius={"md"}
        _hover={{
          transform: "scale(1.05)",
          boxShadow: `none`,
        }}
      >
        <Image
          firebaseStoragePath={
            thumbnailFileName
              ? `photos/${props.user?.id}/${props.id}/thumbnails/${thumbnailFileName}`
              : null
          }
          h="90px"
          w="full"
          onLoad={attachImage}
        />
      </Box>
      <Grid w="full" h="full" gridTemplateRows={"1fr auto"} rowGap={"3"}>
        <VStack
          w="full"
          spacing={"0"}
          align={"flex-start"}
          justify={"flex-start"}
        >
          <Text
            noOfLines={"2"}
            fontSize={"13px"}
            fontWeight={"bold"}
            _hover={{ textDecor: "underline" }}
            cursor={"pointer"}
            onMouseEnter={() => setIsNameHovered(true)}
            onMouseLeave={() => setIsNameHovered(false)}
            as={Link}
            to={`/user/${props.user?.username}/post/${props.id}`}
            onClick={(e) => e.stopPropagation()}
          >
            {props.title}
          </Text>

          <Text color={"gray.400"} fontSize={"10px"}>
            {props.user?.fullName}
          </Text>
        </VStack>
        <AnimatePresence mode="wait">
          {!isContainerHovered ? (
            <MotionBox
              key="duration"
              initial={{ opacity: 0.9, translateY: -1 }}
              animate={{ opacity: 1, translateY: 0 }}
              exit={{ opacity: 0, translateY: -10 }}
              transition={{ ease: "linear", duration: 0.03 }}
            >
              <Text fontSize={"xs"} color="gray.400">
                {MusicCard.formatDuration(props.duration)}
              </Text>
            </MotionBox>
          ) : (
            <MotionBox
              key="access_buttons"
              initial={{ opacity: 0, translateY: 10 }}
              animate={{ opacity: 1, translateY: 0 }}
              exit={{ opacity: 0, translateY: 10 }}
              transition={{ ease: "linear", duration: 0.07 }}
            >
              {!isNameHovered ? (
                <MotionBox
                  key="btn_play"
                  initial={{ opacity: 0, translateY: -10 }}
                  animate={{ opacity: 1, translateY: 0 }}
                  exit={{ opacity: 0, translateY: -10 }}
                  transition={{ ease: "linear", duration: 0.07 }}
                >
                  <HStack color={"gray.500"}>
                    <FiPlay size={10} />
                    <Text fontSize={"10px"}>Click to play</Text>
                  </HStack>
                </MotionBox>
              ) : (
                <MotionBox
                  key="btn_goToPost"
                  initial={{ opacity: 0, translateY: 10 }}
                  animate={{ opacity: 1, translateY: 0 }}
                  exit={{ opacity: 0, translateY: 10 }}
                  transition={{ ease: "linear", duration: 0.07 }}
                >
                  <HStack color={"gray.500"}>
                    <FiArrowRight size={10} />
                    <Text fontSize={"10px"}>Go To Post</Text>
                  </HStack>
                </MotionBox>
              )}
            </MotionBox>
          )}
        </AnimatePresence>
      </Grid>
    </Grid>
  );
};

/**
 * @param {MusicProps} props
 */
MusicCard.InPost = function InPostCard(props) {
  const { playTrack } = useHlsAudioActions();
  const thumbnailFileName =
    props.track?.thumbnails?.[props.track?.thumbnails?.length - 1]?.fileName;

  const MotionText = motion(Text);
  const [imageHovered, setImageHovered] = useState(false);

  async function performPlay() {
    const { container, overlay, ..._rest } = props;
    await playTrack(props.profileId, props.postId, _rest);
  }
  return (
    <VStack
      // gridArea={"2 / 1 / 3 / 2"}
      pos="relative"
      borderRadius={"lg"}
      overflow={"hidden"}
      {...props.container}
    >
      <Image
        firebaseStoragePath={
          thumbnailFileName
            ? `photos/${props.user?.id}/${props.id}/thumbnails/${thumbnailFileName}`
            : null
        }
        borderRadius={"lg"}
        h="full"
        w="full"
        onMouseEnter={() => setImageHovered(true)}
        onMouseLeave={() => setImageHovered(false)}
      />

      <HStack
        //   h="40%"
        pos="absolute"
        bgGradient={"linear(to-t, #212123, transparent)"}
        bottom={"0"}
        zIndex={"2"}
        w="full"
        //   h="max-content"
        pb="1"
        justify={"flex-start"}
        {...props.overlay}
      >
        <ButtonGroup
          spacing={"0"}
          _hover={{
            bg: "#2a2a2c",
          }}
          borderRadius={"md"}
        >
          <IconButton
            icon={<FaPlay />}
            variant={"nav"}
            bg="transparent"
            py="3"
            transition={"none"}
            onClick={performPlay}
          />
          <IconButton
            icon={<CgChevronDown />}
            variant={"nav"}
            bg="transparent"
            py="3"
            transition={"none"}
            minW="0"
            px="1"
          />
        </ButtonGroup>
        <Text
          noOfLines={1}
          textShadow="0 2px 8px rgba(0,0,0,0.7)"
          fontWeight={"semibold"}
        >
          {props.title}
        </Text>
      </HStack>
    </VStack>
  );
};

/**
 * @param {MusicProps} props
 */
MusicCard.InPlaylist = function InPlaylistCard(props) {
  return (
    <Grid
      gridTemplateColumns={"1fr"}
      w="full"
      px="2"
      py="1.5"
      border="1px solid transparent"
      borderRadius={"sm"}
      _hover={{
        bg: "#212123",
        border: "1px solid #3e3e46",
      }}
      cursor={"pointer"}
      alignItems={"center"}
      mb="1.5"
    >
      <VStack align={"flex-start"} spacing={"0"}>
        <Text fontSize={"13px"}>{props.title}</Text>
        <Text fontSize={"12px"} color="gray.300">
          {formatUsername(props.username)} -{" "}
          {MusicCard.formatDuration(props.durationSec)}
        </Text>
      </VStack>
      {/* <Lottie
        animationData={waveformAnim}
        loop
        style={{ height: "30px", width: "30px" }}
      /> */}
    </Grid>
  );
};

/**
 * @param {MusicProps} props
 */
MusicCard.VerticalCard = function VerticalCard(props) {
  const { attachImage, accentColor, counterColor } = useColorAccent();
  const navigate = useNavigate();

  const thumbnailFileName =
    props.thumbnails?.[props.thumbnails?.length - 1]?.fileName;

  function navigateToPost() {
    navigate(`/user/${props.username}/post/${props.postId}`);
  }

  return (
    <VStack
      bg={accentColor}
      borderRadius={"lg"}
      align={"flex-start"}
      pb="2.5"
      cursor={"pointer"}
      transformOrigin={"top center"}
      transition={"all 100ms"}
      _hover={{
        transform: "scale(1.03)",
      }}
      onClick={navigateToPost}
      {...props.container}
    >
      <Box
        w="full"
        // Ensures a 1:1 (square) aspect ratio for the image container
        aspectRatio={4 / 4}
        pos="relative"
        overflow="hidden"
        borderRadius="md"
      >
        <Image
          firebaseStoragePath={
            thumbnailFileName
              ? `photos/${props.profileId}/${props.postId}/thumbnails/${thumbnailFileName}`
              : null
          }
          w="full"
          h="full"
          objectFit="cover"
          borderRadius="md"
          onLoad={attachImage}
        />
        <Box
          pos="absolute"
          h="30%"
          w="full"
          bottom="0"
          left="0"
          right="0"
          bgGradient={`linear(to-t, ${accentColor} 0%, ${accentColor}80 60%, transparent 100%)`}
        />
      </Box>
      <VStack
        w="full"
        align={"flex-start"}
        spacing={"0"}
        px="2"
        h="40px"
        mt="-2"
      >
        <Text fontSize={"sm"} fontWeight={"semibold"} noOfLines={1}>
          {props.title}
        </Text>
        <Text fontSize={"xs"} noOfLines={1}>
          {props.username}
        </Text>
      </VStack>
    </VStack>
  );
};

export default MusicCard;
